<template>
    <div id="feature-card" @click="gotoPlans">
        <div class="water-mark" v-if="!currentPlan">
            <SupsisButton :primary="true"> Satın Al</SupsisButton>
        </div>
        <div class="feature-logo">
            <TeamIntegration v-if="plan.dynamicType === 'team-integration'" />
            <TicketSystem v-if="plan.dynamicType === 'ticket-system'" />
            <TelegramEntegration v-if="plan.dynamicType === 'telegram'" />
            <AIAssistant v-if="plan.dynamicType === 'ai-assistant'" />
            <VisitorChatStart v-if="plan.dynamicType === 'visitor-chat-start'" />
            <WebhookIntegration v-if="plan.dynamicType === 'webhook-integration'" />
            <TaskManagment v-if="plan.dynamicType === 'task-management'" />
            <MailEntegration v-if="plan.dynamicType === 'mail-entegration'" />
            <SoftwareSupport v-if="plan.dynamicType === 'software-support'" />
        </div>
        <div class="feature-content">
            <div class="content">
                <div class="title">
                    {{ plan.altTitle }}
                </div>
                <div v-if="currentPlan">
                    <div v-if="detailPackage().renewed">
                        <b>Yenilenme Tarihi:</b>
                        <div>{{ detailPackage().endDate }}</div>
                    </div>
                    <div v-else>
                        <b>Kalan Süre:</b>
                        <div>{{ detailPackage().leftTime }} gün</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import moment from "moment/moment";
import SoftwareSupport from "./svg/features/SoftwareSupport.vue";
import MailEntegration from "./svg/features/MailEntegration.vue";
import AIAssistant from "./svg/features/AIAssistant.vue";
import TaskManagment from "./svg/features/TaskManagment.vue";
import TeamIntegration from "./svg/features/TeamIntegration.vue";
import TelegramEntegration from "./svg/features/TelegramEntegration.vue";
import TicketSystem from "./svg/features/TicketSystem.vue";
import WebhookIntegration from "./svg/features/WebhookIntegration.vue";
import VisitorChatStart from "./svg/features/VisitorChatStart.vue";

export default {
    name: "FeatureCard",
    props: ["plan", "currentPlan"],
    components: {
        DynamicSvg,
        SupsisButton,
        SoftwareSupport,
        MailEntegration,
        AIAssistant,
        TaskManagment,
        TeamIntegration,
        TelegramEntegration,
        TicketSystem,
        WebhookIntegration,
        VisitorChatStart,
    },
    methods: {
        detailPackage() {
            let detail = {
                enabled: false,
                renewed: false,
                leftTime: 0,
                endDate: null,
            };
            if (this.currentPlan) {
                const isYearly = this.currentPlan.period === "annual";
                const startDate = moment();
                detail.leftTime = moment(this.currentPlan.endDate).diff(startDate, "days");
                if (this.currentPlan.enabled && !this.currentPlan.endDate) {
                    detail.renewed = true;
                    detail.endDate = moment()
                        .add(1, isYearly ? "year" : "month")
                        .startOf(isYearly ? "year" : "month")
                        .format("YYYY/MM/DD");
                }
                detail.enabled = true;
            }
            return detail;
        },
        getFeatureLogo() {
            const logos = {
                mail: "texture_minus",
                task: "texture_minus",
                calender: "texture_minus",
                removeSupsisLogo: "texture_minus",
            };
            return logos[this.plan.dynamicType];
        },
        gotoPlans() {
            this.$router.push(`/billing/plans/${this.plan.dynamicType}`);
        },
    },
};
</script>
<style lang="scss">
#feature-card {
    padding: 15px 15px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    border: 1px solid var(--color-border-default);
    .feature-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            width: 50px;
            height: 50px;
        }
    }
    .water-mark {
        position: absolute;
        background: rgb(110 110 110 / 39%);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: end;
        padding-right: 10px;
    }

    .feature-content {
        display: flex;
        line-height: normal;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .content {
            display: flex;
            flex-direction: column;
        }
        .title {
            font-weight: bold;
            font-size: 17px;
        }
        .active-btn {
            background: #ec4b1d;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
        }
    }
}
</style>
